import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { updateRole } from "../../api/apiRoles";
import parseError from "../../utils/parseError";

export const useUpdateRole = () => {
    const queryClient = useQueryClient();
    const { mutate: updateRoleMutate, isPending: isUpdating } = useMutation({
        mutationFn: ({ id, data }) => updateRole(id, data),
        onSuccess: (res) => {
            toast.success(res.message || "Role updated");
            queryClient.invalidateQueries(["roles"]);
            queryClient.invalidateQueries(["role"]);
        },
        onError: (e) => toast.error(parseError(e) || "Failed to update role"),
    });
    return { updateRoleMutate, isUpdating };
};
